import React from "react";
import { education } from "../data";

export default function Education() {
  return (
    <section id="education">
      <div className="container">
        <p className="section-label">education</p>
        {education.map((entry) => (
          <div key={entry.school} className="exp-row">
            <div className="item-date">{entry.startDate} – {entry.endDate}</div>
            <div>
              <div className="exp-title">{entry.school}</div>
              <div className="exp-company">{entry.degree}</div>
              {entry.courses && (
                <div className="coursework">
                  <span className="coursework-label">coursework</span>
                  <div className="course-list">
                    {entry.courses.map((course) => (
                      <span key={course.code} className="course-item">
                        {course.link ? (
                          <a href={course.link} target="_blank" rel="noopener noreferrer" className="course-link">
                            {course.name} <span className="course-code">({course.code})</span> ↗
                          </a>
                        ) : (
                          <>
                            {course.name} <span className="course-code">({course.code})</span>
                          </>
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
